import React from "react";
import {ShippingItem} from "./ShippingItem";
import {ShippingWithdrawal} from "./ShippingWithdrawal";

export const ShippingMethodRow = ({fee, shippingMethods}) => {
  const items = [];
  const feeItemsCopy = [...fee.items];
  const itemsLength = feeItemsCopy.length;
  let showShippingMethods = true;

  // If shipping methods can be grouped, only display the first item shipping methods
  if (itemsLength && fee.itemsCanBeGrouped) {
    const item = feeItemsCopy.shift();
    items.push(<ShippingItem key={0} item={item} fee={fee} shippingMethods={shippingMethods}
                             showShippingMethods={showShippingMethods} lastItem={itemsLength === 1}/>);
    showShippingMethods = false;
  }

  feeItemsCopy.forEach((item, index) => {
    items.push(<ShippingItem key={index + 1} item={item} fee={fee}
                             shippingMethods={shippingMethods}
                             showShippingMethods={showShippingMethods}
                             lastItem={itemsLength === index + 1}/>);
  });

  const shippingMethodSelected = shippingMethods[fee.shippingMethodId];

  return (
    <div className="card">
      <div className="row fix-spacing">
        <div className="large-12 medium-12 small-12 columns">{items}</div>
      </div>
      <div className="card__footer row text-center">
        {Object.keys(shippingMethodSelected !== undefined ? shippingMethodSelected.pointList : []).length > 0 &&
        <ShippingWithdrawal shippingMethod={shippingMethodSelected}/>
        }
      </div>
    </div>
  );
};

